import React, { memo, useId } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { cardSx } from './styles';

interface FormCardProps {
  icon: React.ReactNode;
  title: string;
  /** Muted text beside the title, e.g. "2 packages · 4 lb total". */
  summary?: React.ReactNode;
  /** Right-aligned header controls. */
  actions?: React.ReactNode;
  children: React.ReactNode;
}

/** Bordered page section with an icon + title header. */
const FormCard: React.FC<FormCardProps> = ({ icon, title, summary, actions, children }) => {
  const titleId = useId();
  return (
    <Box component="section" aria-labelledby={titleId} sx={{ ...(cardSx as object), display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <Box aria-hidden sx={{ display: 'flex', color: 'primary.dark', '& svg': { fontSize: 22 } }}>
          {icon}
        </Box>
        <Typography id={titleId} component="h2" sx={{ fontSize: 18, fontWeight: 600 }}>
          {title}
        </Typography>
        {summary && <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>{summary}</Typography>}
        {actions && <Box sx={{ ml: 'auto', display: 'flex', gap: 1, flexWrap: 'wrap' }}>{actions}</Box>}
      </Box>
      {children}
    </Box>
  );
};

export default memo(FormCard);
